const TOKEN_KEY = 'token'
const NAME_KEY = 'username'
const WordCloud_KEY = 'wordcloud'
const localStorage = window.localStorage

export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY)
}

export const setToken = token => {
  localStorage.setItem(TOKEN_KEY, token)
}

export const removeToken = () => {
  localStorage.removeItem(TOKEN_KEY)
}

export const getName = () => {
  return localStorage.getItem(NAME_KEY)
}
export const setName = name => {
  localStorage.setItem(NAME_KEY, name)
}
export const removeName = () => {
  localStorage.removeItem(NAME_KEY)
}

// 存储对象数组
export const getWordcloud = () => {
  let wordClouds = localStorage.getItem(WordCloud_KEY);
  if (wordClouds) {
    let item = JSON.parse(wordClouds);
    return item
  }
}
export const setWordcloud = data => {
  let wordCloud = JSON.stringify(data); //将json对象转化成字符串
  localStorage.setItem(WordCloud_KEY, wordCloud); //把选择的数据存储在localstorage中
}